import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Apiservice } from '../../services/api.service';
import { ItemRenderedEvent } from 'devextreme/ui/accordion';
import { DxAccordionComponent } from 'devextreme-angular';
import { NgxSpinnerService } from 'ngx-spinner';

export interface Procedura {
  id: number;
  CodContatto: number;
  CodSede: number;
  CodModulo: number;
  id_master_procedura: number;
  procedura_attiva: number | string;
  dataAttivazione: string;
  dataScadenza: string;
  note: string;
  quantita: number;
  keycode: number;
  Licenza: string;
  Assistenza: string;
  ApplicaIstat: number;
  RateoIniziale: number;
  des: string;
  accettaModuli: string;
  Sigla: string;
  Ind: string;
  Loc: string;
  Prov: string;
  moduli: Moduli[];
}

export interface Moduli {
  id: number;
  CodContatto?: number;
  CodSede?: number;
  CodProcedura?: number;
  CodModulo?: number;
  id_master_procedura?: number;
  procedura_attiva?: number | string;
  dataAttivazione?: string;
  dataScadenza?: string;
  note?: string;
  quantita?: number;
  keycode?: number;
  Licenza?: string;
  RateoIniziale?: number;
  Assistenza?: string;
  ApplicaIstat?: number;
  des?: string;
  Sigla?: string;
}

@Component({
  selector: 'app-riepilogo-procedura',
  templateUrl: './riepilogo-procedura.component.html',
  styleUrls: ['./riepilogo-procedura.component.css'],
})
export class RiepilogoProceduraComponent implements OnInit {
  @Input() procedura: any = []
  @ViewChild('accordion', { static: false }) dxAccordion: DxAccordionComponent;
  totalCount: number = 0;
  totalLicenza: number = 0;
  originalData: any = []
  textSwitch: string = 'Calcolo per Canone'
  licenza: boolean = false;
  useRateo: boolean = false;
  isReady: boolean = false;
  stato = [
    { id: 1, descrizione: '✅' },
    { id: 2, descrizione: '⏳' },
    { id: 0, descrizione: '❌' }
  ]

  key = [
    { key: true, des: 'Calcola costi per canone.' },
    { key: false, des: 'Calcola costi per rateo.' },
  ];
  constructor(
    private api: Apiservice,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    // Clona i dati originali per evitare modifiche accidentali
    this.originalData = JSON.parse(JSON.stringify(this.procedura));
    // Calcola il totale iniziale
    this.getTotalCount(this.originalData);

    // Filtra le procedure attive
    this.procedura = this.procedura.filter((item: Procedura) => item.procedura_attiva === 1);

    // Mappa e modifica le procedure e i loro moduli
    this.procedura = this.procedura.map((procedura: Procedura) => {
      this.getStato(procedura);

      if (procedura.dataAttivazione) {
        procedura.dataAttivazione = new Date(procedura.dataAttivazione).toLocaleDateString();
        //procedura.dataAttivazione = this.formatDate(procedura.dataAttivazione);
      }
      if (procedura.dataScadenza) {
        procedura.dataScadenza = new Date(procedura.dataScadenza).toLocaleDateString();
      }

      if (procedura.Assistenza) {
        const valore = this.toNumber(procedura.Assistenza) * procedura.quantita;

        procedura.Assistenza = this.toItalianFormat(valore);
      }

      if (procedura.Licenza) {
        const valore = this.toNumber(procedura.Licenza) * procedura.quantita;
        console.log('valoreeeeeee', valore)
        procedura.Licenza = this.toItalianFormat(valore);
      }


      // Filtra i moduli attivi
      procedura.moduli = procedura.moduli.filter((modulo: Moduli) => modulo.procedura_attiva === 1);

      // Modifica i moduli
      procedura.moduli = procedura.moduli.map((modulo: Moduli) => {
        this.getStato(modulo);

        if (modulo.dataAttivazione) {
          modulo.dataAttivazione = new Date(modulo.dataAttivazione).toLocaleDateString();
          //procedura.dataAttivazione = this.formatDate(procedura.dataAttivazione);
        }
        if (modulo.dataScadenza) {
          modulo.dataScadenza = new Date(modulo.dataScadenza).toLocaleDateString();
        }

        if (modulo.Assistenza) {
          const valore = this.toNumber(modulo.Assistenza) * modulo.quantita;
          modulo.Assistenza = this.toItalianFormat(valore);
        }

        if (modulo.Licenza) {
          const valore = this.toNumber(modulo.Licenza) * modulo.quantita;
          modulo.Licenza = this.toItalianFormat(valore);
        }

        return modulo;
      });

      // Isola la procedura senza l'array dei moduli
      const proceduraSenzaModuli = { ...procedura };
      delete proceduraSenzaModuli.moduli; // Elimina la proprietà moduli

      // Aggiungi la procedura stessa come ultimo elemento dell'array moduli
      if (!procedura.moduli.some((modulo: Moduli) => modulo.id === procedura.id)) {
        procedura.moduli.unshift(proceduraSenzaModuli);
      }
      this.isReady = true;
      return procedura;
    });

    // Imposta il flag per indicare che i dati sono pronti

    //console.log('Dati finali dopo la modifica:', this.procedura);
  }

  getTotalCount(items: Procedura[]) {
    this.totalCount = 0
    this.totalLicenza = 0

    //filtro le procedure in entrata tenendo in considerazione solo quelle attive
    const procedureAttive = items.filter((item) => item.procedura_attiva === 1);
    procedureAttive.forEach((proc: any) => {
      const assistenzaProcedura = this.toNumber(proc.Assistenza);
      const costoLicenza = this.toNumber(proc.Licenza)
      const quantiProcedura = proc.quantita || 1;
      this.totalCount += assistenzaProcedura * quantiProcedura;
      this.totalLicenza += costoLicenza * quantiProcedura;
      //dopo aver verificato le procedure attive, verifico i moduli attivi ciclando procedureAttive
      if (proc.moduli && Array.isArray(proc.moduli)) {
        const moduliAttivi = proc.moduli.filter((modulo: Moduli) => modulo.procedura_attiva === 1);
        //ciclo i moduli attivi e sommo il totalCount precedentemente calcolato
        //con il totale dell'assistenza modulo moltiplicato per la quantità
        moduliAttivi.forEach((mod: any) => {
          const assistenzaModulo = this.toNumber(mod.Assistenza);
          const costoLicenza = this.toNumber(mod.Licenza)
          const quantiModulo = mod.quantita || 1;
          this.totalCount += assistenzaModulo * quantiModulo!;
          this.totalLicenza += costoLicenza * quantiModulo;
        })
      }
    })
  }

  getTotalGroup(procedura: any, dataField: string): number {
    let totalGroup = 0;
    // Aggiungi i valori dei moduli (se presenti)
    if (procedura.moduli && Array.isArray(procedura.moduli)) {
      totalGroup += procedura.moduli.reduce((sum, modulo) => {
        return sum + (this.toNumber(modulo[dataField]));
      }, 0);
    }

    return totalGroup;
  }

  getStato(procedura: any) {
    //gli passo l'array e in base allo stato incluso nell'array di stato gli assegno la descrizione
    if (procedura.procedura_attiva !== undefined) {
      procedura.procedura_attiva = this.stato.find((s) => s.id === procedura.procedura_attiva).descrizione;
    }
  }

  onItemRendered(e: ItemRenderedEvent) {
    this.dxAccordion.instance.expandItem(e.itemIndex)
  }

  onValueChangedRadio(e: any) {
    if (this.useRateo !== !e.value.key) {
      this.useRateo = !e.value.key;
      this.textSwitch = e.value.key ? 'Calcolo per Canone' : 'Calcolo per Rateo';
      this.getTotalCount(this.originalData);
    }
  }

  onValueChangedCheckBox(e: any) {
    this.licenza = e.value
    this.getTotalCount(this.originalData)
    // this.getTotalGroup(this.originalData)
  }

  private toItalianFormat(num: number): string {
    return new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  }

  private toNumber(val: string | number): number {
    if (val === null || val === undefined) return 0;
    if (typeof val === 'number') return val;
    const cleaned = val.replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }
}